const isValidMonth = (month) => month
    && month.length === 2
    && parseInt(month, 10) > 0 && parseInt(month, 10) <= 12;

const isValidYear = (year) => {
    const currentYear = new Date().getFullYear();
    const currentYear2Digits = parseInt(currentYear.toString().substr(-2), 10);

    return year
    && year.length === 2
    && parseInt(year, 10) >= currentYear2Digits && parseInt(year, 10) <= currentYear2Digits + 10;
};

module.exports = Backbone.Model.extend({
    defaults: {
        cardExpirationMonth: {
            value: '',
        },
        cardExpirationYear: {
            value: '',
        },
        validationStatus: 'init',
    },

    initialize() {
        this.on('change:cardExpirationMonth', this.updateStatus);
        this.on('change:cardExpirationYear', this.updateStatus);
    },

    updateStatus(model) {
        const year = model.get('cardExpirationYear').value;
        const month = model.get('cardExpirationMonth').value;
        if (isValidYear(year) && isValidMonth(month)) {
            this.set('validationStatus', 'valid');
        }
    },

    getValidationStatus(year, month) {
        return isValidYear(year) && isValidMonth(month) ? 'valid' : 'invalid';
    },

    isValidMonth() {
        return isValidMonth(this.get('cardExpirationMonth').value);
    },

    isValidYear() {
        return isValidYear(this.get('cardExpirationYear').value);
    },
    isEmpty(name) {
        return this.get(name).value === '';
    },
    checkValid() {
        const isValid = this.getValidationStatus(this.get('cardExpirationYear').value, this.get('cardExpirationMonth').value);
        const previousValid = this.get('validationStatus');
        this.set({validationStatus: isValid}, {silent: true});
        this.triggerChangeToTrackSubmit(isValid, previousValid);
    },
    validate() {
        return this.isValidMonth() && this.isValidYear();
    },
    save() {},
    fetch() {},
});
